export default "__VITE_ASSET__Cc30fmVq__"